export const ROUTE_NAMES = {
  MAP: 'Carte',
  EMBED: 'Carte embarquée',
  LOGIN: 'Se connecter',
  LOGOUT: 'Se deconnecter',
  BOOKMARKS: 'Favoris',
  PLAN: 'Plan',
} as const;
